import React from "react";
import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import mosquito from "../assets/background.jpeg";
export default function Home() {
  const { currentUser } = useAuth();

  return (
    <Container
      className=" align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <br />
      <br />
      <br />
      <br />

      <h1 className="text-center">Larva ID</h1>
      <img
        src={mosquito}
        alt="mosquito"
        width="600"
        style={{
          position: "center",
          textAlign: "center",
          display: "block",
          justifyContent: "center",
          alignContent: "center",
          margin: "auto",
        }}
      />
      <br />
      <h3 className="text-center">
        Welcome! Thank you for registering. You will be contacted about the next steps.
      </h3>
      <br />
      <br />
      <br />
      <br />
    </Container>
  );
}
